import React, { useEffect, useState, useContext, useRef } from 'react'
import SideNav from './SideNav'
import TopRootDiv from './TopRootDiv';
import SherDineNav from './SherDineNav';
import './css/KitchenDisplaySystem.css'
import Table from './images/icons/Roundtable1.png'
import remove from './images/icons/remove.png'
import Close from "./images/icons/delete.png";
import io from 'socket.io-client';
import axios from 'axios'
import SideNavMob from './SideNavMob'
import RightNavMob from './RightNavMob'
import NavBarMobile from './Mobile/NavBar'
import { DBContext } from './DBContext'
import { useCallback } from 'react';

function KitchenDisplaySystem() {

    const { logginedDB, sideNavState, sideNavStateFunc, rightNavState, rightNavStateFunc, hasPermission = () => true } = useContext(DBContext);
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

    const [start, setStart] = useState(true)
    const [pause, setPause] = useState()
    const [finish, setfinish] = useState()
    const [areaNames, setAreaNames] = useState({});
    const [runningKot, setRunningKot] = useState([])
    const [cancelItemModal, setCancelItemModal] = useState(null);
    const [remarks, setRemarks] = useState('');
    const [selectedOption, setSelectedOption] = useState('');
    const [timers, setTimers] = useState({});


    // Fetch area names for all unique floor IDs in runningKot
    const fetchAreaNames = async () => {
        try {
            const uniqueFloors = [...new Set(runningKot.map(kot => kot.floor))];

            const fetchedAreaNames = {};
            for (const floor of uniqueFloors) {
                if (floor) {
                    const response = await axios.get(`${apiBaseUrl}/getAreaName/${floor}/${logginedDB}`);
                    if (response.status === 200) {
                        fetchedAreaNames[floor] = response.data.AreaName;
                    }
                }
            }

            setAreaNames(fetchedAreaNames);
        } catch (error) {
            console.error(error);
        }
    };

    const handleFoodIsReady = async (kot) => {
        try {
            const response = await axios.post(`${apiBaseUrl}/foodIsReady/${kot.KotNo}/${0}/${kot.tableno ? kot.tableno : 'noTable'}/${kot.floor}/${logginedDB}`)
            if (response.status == 200) {

            }
        } catch (error) {
            console.error(error);
        }
    }

    // const handleCancel = async (kot) => {
    //     console.log(kot, "CancelAllKitchen")
    //     try {
    //         const response = await axios.post(`${apiBaseUrl}/CancelAllKitchen/${logginedDB}`, {
    //             body: JSON.stringify(kot)
    //         });           
    //         if (response.status == 200) {
    //             console.log(response);

    //         }
    //     } catch (error) {
    //         console.error(error);
    //     }
    // }

    const handleCancel = async (kot) => {
        if (!hasPermission('cancelKOT')) {
            alert("You do not have permission to cancel KOTs / orders!");
            return;
        }
        console.log(kot, "CancelAllKitchen")
        try {
            const response = await axios.post(`${apiBaseUrl}/CancelAllKitchen/${logginedDB}`, {
                kot: kot
            });
            if (response.status == 200) {
                console.log(response);
                // Remove the KOT from local state immediately
                setRunningKot(prevKots => prevKots.filter(k => k.KotNo !== kot.KotNo));
            }
        } catch (error) {
            console.error(error);
        }
    }

    // Item cancellation handlers
    const handleRemarks = (e) => {
        setRemarks(e.target.value);
    };

    const handleOptionSelect = (option) => {
        const addSpace = remarks.length > 0 && !remarks.endsWith(' ');
        setRemarks(prev => prev + (addSpace ? ' ' : '') + option + ' ');
        setSelectedOption(option);
    };

    const handleNumberSelect = (number) => {
        const addSpace = remarks.length > 0 && !remarks.endsWith(' ') && isNaN(parseInt(remarks.slice(-1)));
        setRemarks(prev => prev + (addSpace ? ' ' : '') + number);
    };

    const handleClearRemarks = () => {
        setRemarks('');
        setSelectedOption('');
    };

    const handleCancelItem = (item, kot) => {
        if (!hasPermission('cancelKOT')) {
            alert("You do not have permission to cancel KOT items!");
            return;
        }
        console.log("handleCancelItem button", item.ItemName, kot.KotNo);
        setCancelItemModal({ item: item, kot: kot });
    };

    const handleConfirmCancelItem = async () => {
        if (!cancelItemModal) return;
        try {
            // console.log("Cancelling item:", cancelItemModal.item, "with remarks:", remarks, "from KOT:", cancelItemModal.kot);

            const KOTNo = cancelItemModal.kot.KotNo;
            console.log(KOTNo, "kt");

            const response = await fetch(`${apiBaseUrl}/ItemRemoveKitchen/${logginedDB}/${KOTNo}`, {
                method: 'DELETE',
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(cancelItemModal)
            });

            console.log("success", response.ok, response);

            if (response.ok) {
                // Update local state immediately
                setRunningKot(prevKots => {
                    return prevKots.map(kot => {
                        if (kot.KotNo === KOTNo) {
                            // Filter out the removed item from this KOT's particulars
                            const updatedItems = kot.particulars.items.filter(
                                item => !(item.Itemid === cancelItemModal.item.Itemid &&
                                    item.variantId === cancelItemModal.item.variantId)
                            );

                            // If no items left, remove the entire KOT
                            if (updatedItems.length === 0) {
                                return null;
                            }

                            return {
                                ...kot,
                                particulars: {
                                    ...kot.particulars,
                                    items: updatedItems
                                }
                            };
                        }
                        return kot;
                    }).filter(kot => kot !== null);
                });

            } else {
                console.log("failed");
            }

            setCancelItemModal(null);
            setRemarks('');
            setSelectedOption('');

        } catch (error) {
            console.error("Error cancelling item:", error);
        }
    };

    const handleCloseCancelModal = () => {
        setCancelItemModal(null);
        setRemarks('');
    };

    useEffect(() => {
        if (runningKot.length > 0) {
            fetchAreaNames();
        }
    }, [runningKot]);

    const handleGetRunningKot = useCallback(async () => {
        try {
            const response = await axios.get(`${apiBaseUrl}/getRunningKot/${logginedDB}`)
            if (response.status === 200) {

                const transformedData = response.data.map(item => {
                    const itemsMap = new Map();

                    item.particulars.forEach(particular => {
                        const key = `${particular.Itemid}_${particular.variantId || "null"}`;

                        // If the item doesn't exist in the map, initialize it
                        if (!itemsMap.has(key)) {
                            itemsMap.set(key, {
                                Itemid: particular.Itemid,
                                variantId: particular.variantId,
                                ItemName: particular.ItemName,
                                VariantName: particular.VariantName,
                                Qty: particular.Qty,
                                note: particular.remarks,
                                addons: []
                            });
                        }

                        // If addonId exists, add it to the addons array
                        if (particular.addonId) {
                            itemsMap.get(key).addons.push({
                                addonId: particular.addonId,
                                addonName: particular.addonName,
                                Qty: particular.Qty
                            });
                        }
                    });

                    // Convert the itemsMap values into an array
                    return {
                        ...item,
                        particulars: {
                            items: Array.from(itemsMap.values())
                        }
                    };
                });
                setRunningKot(transformedData)
            }
        } catch (error) {
            console.error(error);
        }
    }, [apiBaseUrl, logginedDB]);


    const socketRef = useRef(null);

    //     useEffect(() => {
    //        if (!logginedDB) return;
    //         // Connect to the WebSocket server
    //         const socket = io(apiBaseUrl);

    //             socketRef.current = io(apiBaseUrl, {
    //             transports: ["websocket"], // faster than polling
    //           });

    //         // socket.on('updateKot', () => {
    //         //     handleGetRunningKot();
    //         // });
    //         // socket.on('updateFoodIsReady', () => {
    //         //     handleGetRunningKot();
    //         // });
    //         // socket.on('updateKitchenItems', () => {
    //         //     handleGetRunningKot();
    //         // });

    //           socketRef.current
    //     .off("updateKot")
    //     .on("updateKot", handleGetRunningKot());

    //   socketRef.current
    //     .off("updateFoodIsReady")
    //     .on("updateFoodIsReady", handleGetRunningKot());

    //   socketRef.current
    //     .off("updateKitchenItems")
    //     .on("updateKitchenItems", handleGetRunningKot());

    //         return () => {
    //           socketRef.current.disconnect();
    //         };
    //     }, [apiBaseUrl, logginedDB]);

    useEffect(() => {
        if (!logginedDB) return;

        handleGetRunningKot(); // Fetch initial data

        socketRef.current = io(apiBaseUrl, {
            transports: ["websocket"],
        });

        // Event listeners
        const updateHandler = () => handleGetRunningKot();

        socketRef.current.on("connect", () => {
            console.log("Connected to server");
        });

        socketRef.current.on("disconnect", () => {
            console.log("Disconnected from server");
        });

        socketRef.current.on("connect_error", (error) => {
            console.error("Connection error:", error);
        });


        socketRef.current.on("updateKot", updateHandler);
        socketRef.current.on("updateFoodIsReady", updateHandler);
        socketRef.current.on("updateKitchenItems", updateHandler);

        return () => {
            if (socketRef.current) {
                socketRef.current.off("updateKot", updateHandler);
                socketRef.current.off("updateFoodIsReady", updateHandler);
                socketRef.current.off("updateKitchenItems", updateHandler);
                socketRef.current.disconnect();
            }
        };
    }, [apiBaseUrl, logginedDB]);

    useEffect(() => {
        const interval = setInterval(() => {
            setTimers((prevTimers) => {
                const updatedTimers = { ...prevTimers };
                Object.keys(updatedTimers).forEach((key) => {
                    updatedTimers[key] = updatedTimers[key] + 1000; // Increment by 1 second
                });
                return updatedTimers;
            });
        }, 1000);

        return () => clearInterval(interval); // Cleanup on unmount
    }, []);

    const initializeTimer = (key, date, time) => {
        if (!timers[key]) {
            const startTime = new Date(`${date} ${time}`).getTime();
            const currentTime = Date.now();
            const elapsedTime = Math.max(0, currentTime - startTime); // Ensure no negative time
            setTimers((prevTimers) => ({ ...prevTimers, [key]: elapsedTime }));
        }
    };

    const formatTime = (ms) => {
        const totalSeconds = Math.floor(ms / 1000);
        const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, '0');
        const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0');
        const seconds = String(totalSeconds % 60).padStart(2, '0');
        return `${hours}:${minutes}:${seconds}`;
    };


    return (
        <div className='w-screen h-screen flex overflow-hidden'>
            <div className='w-full h-full overflow-hidden hidden sm:flex sm:flex-col'>
                <SherDineNav />
                <div className='w-full bg-[#f5f5f5] flex-grow flex gap-3 overflow-hidden'>
                    <div className='w-max h-full z-[9999]'>
                        <SideNav focus={'Order & Billing'} />
                    </div>
                    <div className='w-full h-full flex flex-col pr-3 pl-0 pb-3 pt-0 gap-3 overflow-hidden'>
                        <div className="pr-3 h-max w-full bg-[#fff] borderBottom">
                            <TopRootDiv image={'Order & Billing'} root={['KOT']} type={'KOT'} />
                        </div>
                        <div className='w-full h-full flex flex-col gap-3 font-nunito overflow-hidden'>
                            <div className='w-full h-max flex justify-end items-center gap-2 bg-[#fff] p-3'>
                                <div className='w-[.75rem] h-[.75rem] rounded-full bg-[#205e1f]'></div>
                                <span className='TStatus_TableView_Text'>Delivery</span>
                                <div className='Line_TableView'></div>
                                <div className='w-[.75rem] h-[.75rem] rounded-full bg-[#ee6824]'></div>
                                <span className='TStatus_TableView_Text'>Limit Exceed</span>
                                <div className='Line_TableView'></div>
                                <div className='w-[.75rem] h-[.75rem] rounded-full bg-[#172e66]'></div>
                                <span className='TStatus_TableView_Text'>Website</span>
                                <div className='Line_TableView'></div>
                                <div className='w-[.75rem] h-[.75rem] rounded-full bg-[#744D29]'></div>
                                <span className='TStatus_TableView_Text'>Other</span>
                                <div className='Line_TableView'></div>
                                <div className='w-[.75rem] h-[.75rem] rounded-full bg-[#FFEE58]'></div>
                                <span className='TStatus_TableView_Text'>Dine In</span>
                                <div className='Line_TableView'></div>
                                <div className='w-[.75rem] h-[.75rem] rounded-full bg-[#3480d7]'></div>
                                <span className='TStatus_TableView_Text'>Pickup</span>
                                <div className='Line_TableView'></div>
                                <div className='w-[.75rem] h-[.75rem] rounded-full bg-[#7c3aed]'></div>
                                <span className='TStatus_TableView_Text'>Parcel</span>
                            </div>
                            <div className='w-full h-full font-nunito overflow-auto customScroll p-1'>
                                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
                                    {
                                        runningKot.length > 0 ? runningKot.map((kot, index) => {

                                            const key = kot.KotNo;
                                            const { Date: date, Time: time } = kot;
                                            initializeTimer(key, date, time);

                                            return (
                                                <div key={index} className='min-h-[20rem] max-h-[25rem] flex flex-col gap-2 b-[#fff] rounded-[.313rem] shadow-md relative overflow-hidden'>
                                                    <div className={`flex w-full h-max p-2 rounded-t-[.313rem] ${kot.Type === 'Dine In' ? 'bg-[#FFEE58] text-[#000]' : kot.Type === 'Pickup' ? 'bg-[#3480d7] text-[#fff]' : kot.Type === 'Delivery' ? 'bg-[#205e1f] text-[#fff]' : kot.Type === 'Parcel' ? 'bg-[#7c3aed] text-[#fff]' : ''}`}>
                                                        <div className='w-full flex flex-col justify-end items-start text-[.8rem]'>
                                                            {kot.Type === 'Dine In' && (
                                                                <div className='flex justify-start items-start gap-1 text-nowrap'>
                                                                    <img className={`w-[1rem] ${kot.Type === 'Dine In' ? 'invert' : ''}`} src={Table} alt="" />
                                                                    <span>{kot.tableno} / {areaNames[kot.floor]}</span>
                                                                </div>
                                                            )}
                                                            <span>KOT #{kot.KotNo}</span>
                                                            <span>{kot.Time}</span>
                                                        </div>
                                                        <div className='w-max flex flex-col justify-start items-center'>
                                                            <div className='DineAndTime_Dine'>
                                                                <div className={kot.Type === 'Dine In' ? 'DineAndTime_Dine_Pause' : ''}>{kot.Type}</div>
                                                            </div>
                                                            {(timers[key] !== undefined && kot.kotstatus !== 3) && (
                                                                <span className='DineAndTime_Time'>
                                                                    {formatTime(timers[key])}
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className='flex flex-col w-full h-full gap-2 overflow-x-hidden overflow-y-auto smallScroll font-nunito'>
                                                        {kot.particulars && kot.particulars.items.map((item, index) => (
                                                            <div key={index} className='w-full h-max flex flex-col text-[.9rem] p-2 opacity-100 bg-[#eeeeee] gap-2'>
                                                                <div className='w-full flex flex-col gap-1'>
                                                                    <div className='w-full flex gap-2'>
                                                                        <span className='w-max text-nowrap'>{item.Qty}</span>
                                                                        <div className='w-full flex flex-col text-left'>
                                                                            <span className=''>{item.ItemName}&nbsp;{item.VariantName && `(${item.VariantName})`}</span>
                                                                        </div>
                                                                        <img className='w-[2rem] opacity-50 cursor-pointer' src={remove} alt="" onClick={() => handleCancelItem(item, kot)} />
                                                                    </div>
                                                                    {item.note &&
                                                                        <div className='w-full h-max flex justify-start items-center gap-2 px-2 text-[.8rem] opacity-75 text-nowrap italic'>
                                                                            <span>&nbsp;&nbsp;[Note]&nbsp;:&nbsp;{item.note}</span>
                                                                        </div>
                                                                    }
                                                                </div>
                                                                {item.addons.length > 0 && (
                                                                    <div className='w-full h-max flex flex-wrap text-[.8rem] text-[#C30000] opacity-75 gap-1 pl-3'>
                                                                        <span>Extra:</span>
                                                                        {item.addons.map((addon, addonIndex) => (
                                                                            <div key={addonIndex} className='flex gap-2'>
                                                                                {addon.Qty}&nbsp;{addon.addonName}
                                                                                {addonIndex < item.addons.length - 1 && ','}
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        ))}
                                                    </div>
                                                    <div className='w-full h-max px-2 pb-2 flex gap-2 font-[500]'>
                                                        <button className='w-max bg-gray-200 flex justify-center items-center rounded-md p-2 focus:outline-none' onClick={() => handleCancel(kot)}>
                                                            <img className='w-[2rem] opacity-50' src={remove} alt="" />
                                                        </button>
                                                        <button className='w-full bg-[#EF5350] text-[#fff] rounded-md py-2 focus:outline-none' onClick={() => handleFoodIsReady(kot)}>Food Is Ready</button>
                                                    </div>
                                                </div>
                                            )
                                        }) : (
                                            <div>
                                                No orders!
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Cancel Item Modal */}
            {cancelItemModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-2 mt-14">
                    <div className="bg-white rounded-lg p-3 max-w-sm w-full max-h-[90vh] overflow-y-auto">
                        <div className="flex justify-between items-center mb-1">
                            <h3 className="text-base font-bold">Cancel Item</h3>
                            <button onClick={handleCloseCancelModal} className="text-gray-500 hover:text-gray-700">
                                <img className="w-4 cursor-pointer" src={Close} alt="Close" />
                            </button>
                        </div>

                        <div className="mb-1 p-1 bg-blue-100 rounded text-sm">
                            <p className="font-semibold">KOT #{cancelItemModal.kot.KotNo}</p>
                            <p className="font-semibold">{cancelItemModal.item.ItemName}</p>
                            {cancelItemModal.item.VariantName && <p className="text-xs">Variant: {cancelItemModal.item.VariantName}</p>}
                            <p className="font-semibold">Qty: {cancelItemModal.item.Qty}</p>
                        </div>

                        {/* Quick Options */}
                        <div className="mb-2">
                            <h4 className="font-semibold mb-1 text-sm">Quick Options:</h4>
                            <div className="grid grid-cols-3 gap-1">
                                {['Item', 'Items', 'Not Available', 'Only', 'Half', 'Full', 'Quarter', 'left'].map((option) => (
                                    <button
                                        key={option}
                                        onClick={() => handleOptionSelect(option)}
                                        className={`p-1 border rounded text-xs ${selectedOption === option
                                            ? 'bg-blue-500 text-white border-blue-500'
                                            : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-100'
                                            }`}
                                    >
                                        {option}
                                    </button>
                                ))}
                            </div>
                        </div>

                        {/* Number Pad */}
                        <div className="mb-2">
                            <h4 className="font-semibold mb-1 text-sm">Numbers:</h4>
                            <div className="grid grid-cols-3 gap-1">
                                {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((number) => (
                                    <button
                                        key={number}
                                        onClick={() => handleNumberSelect(number)}
                                        className="p-2 border border-gray-300 rounded bg-white hover:bg-gray-100 text-sm font-semibold"
                                    >
                                        {number}
                                    </button>
                                ))}
                                <button
                                    onClick={() => handleNumberSelect(0)}
                                    className="p-2 border border-gray-300 rounded bg-white hover:bg-gray-100 text-sm font-semibold col-span-2"
                                >
                                    0
                                </button>
                                <button
                                    onClick={handleClearRemarks}
                                    className="p-2 border border-gray-300 rounded bg-red-500 text-white hover:bg-red-600 text-sm"
                                >
                                    Clear
                                </button>
                            </div>
                        </div>

                        {/* Remarks Textarea */}
                        <div className="mb-2">
                            <h4 className="font-semibold mb-1 text-sm">Remarks:</h4>
                            <textarea
                                rows={2}
                                className="w-full rounded border border-gray-300 p-2 text-sm focus:outline-none focus:border-blue-500"
                                value={remarks}
                                onChange={handleRemarks}
                                placeholder="Type or use options above..."
                            />
                        </div>

                        <div className="flex justify-end gap-2">
                            <button
                                onClick={handleCloseCancelModal}
                                className="px-3 py-1 bg-gray-200 rounded text-sm hover:bg-gray-300"
                            >
                                Close
                            </button>
                            <button
                                onClick={handleConfirmCancelItem}
                                className="px-3 py-1 bg-red-500 text-white rounded text-sm hover:bg-red-600 disabled:bg-gray-300 disabled:cursor-not-allowed"
                                disabled={!remarks.trim()}
                            >
                                Confirm
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default KitchenDisplaySystem
